import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user'
import energy from './modules/energy'
import pcsList from './modules/pcsList'
import dcdcList from './modules/dcdcList'
import integratedList from './modules/integratedList'
import bmsList from './modules/bmsList'
import bmsInnerList from './modules/bmsInnerList'
import tmsList from './modules/tmsList'
import photovoltaicList from './modules/photovoltaicList'
import workOrder from './modules/workOrder'
Vue.use(Vuex)
import { removeCookie, removeStationsId, removeEmsId, removeToken } from '@/utils/auth'
const store = new Vuex.Store({
  // state 持久化，防止f5刷新，导致数据消失
  plugins: [
    createPersistedState({
      key: 'strategyList',
      paths: ['energy']
    }),
    createPersistedState({
      key: 'pcsList',
      paths: ['pcsList']
    }),
    createPersistedState({
      key: 'photovoltaicList',
      paths: ['photovoltaicList']
    }),
    createPersistedState({
      key: 'integratedList',
      paths: ['integratedList']
    }),
    createPersistedState({
      key: 'bmsList',
      paths: ['bmsList']
    }),
    createPersistedState({
      key: 'bmsInnerList',
      paths: ['bmsInnerList']
    }),
    createPersistedState({
      key: 'dcdcList',
      paths: ['dcdcList']
    }),
    createPersistedState({
      key: 'tmsList',
      paths: ['tmsList']
    })
  ],

  modules: {
    energy,
    user,
    workOrder,
    pcsList,
    photovoltaicList,
    integratedList,
    bmsList,
    bmsInnerList,
    dcdcList,
    tmsList
  },
  actions: {
    /** @description 清除存储数据 */
    resetAll({ commit }) {
      removeToken('Token')
      removeCookie('UserName')
      removeCookie('Permission')
      removeCookie('config')
      removeCookie('isCollapse')
      removeCookie('setPowerTip')
      removeCookie('setDescTip')
      removeCookie('setProfitTip')
      removeStationsId('stationId')
      removeEmsId('emsId')
      removeCookie('customerId')
      removeCookie('strategyList')
      removeCookie('pcsList')
      removeCookie('bmsList')
      removeCookie('bmsInnerList')
      removeCookie('photovoltaicList')
      removeCookie('tmsList')
      removeCookie('integratedList')
      removeCookie('dcdcList')
    }
  }
})
export default store
